/* tslint:disable */
/* eslint-disable */
/**
 * Relays-Online
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ContactSalesSupportCommand,
    ContactSalesSupportCommandFromJSON,
    ContactSalesSupportCommandToJSON,
    CriteriaSortItem,
    CriteriaSortItemFromJSON,
    CriteriaSortItemToJSON,
    DownloadOrderItemsFilesQuery,
    DownloadOrderItemsFilesQueryFromJSON,
    DownloadOrderItemsFilesQueryToJSON,
    OrderDetailsVm,
    OrderDetailsVmFromJSON,
    OrderDetailsVmToJSON,
    OrderItemsVm,
    OrderItemsVmFromJSON,
    OrderItemsVmToJSON,
    OrderLicensesVm,
    OrderLicensesVmFromJSON,
    OrderLicensesVmToJSON,
    OrderMetaDataVm,
    OrderMetaDataVmFromJSON,
    OrderMetaDataVmToJSON,
    OrderNotificationsMetadataVm,
    OrderNotificationsMetadataVmFromJSON,
    OrderNotificationsMetadataVmToJSON,
    OrderNotificationsVm,
    OrderNotificationsVmFromJSON,
    OrderNotificationsVmToJSON,
    OrderSearchStatus,
    OrderSearchStatusFromJSON,
    OrderSearchStatusToJSON,
    OrdersVm,
    OrdersVmFromJSON,
    OrdersVmToJSON,
    ShippingDetailDocumentTypes,
    ShippingDetailDocumentTypesFromJSON,
    ShippingDetailDocumentTypesToJSON,
} from '../models';

export interface ApiOrderDetailsGetRequest {
    orderIdentifier?: string;
}

export interface ApiOrderGetRequest {
    criteriaPage: number;
    criteriaPageSize: number;
    criteriaCompanyId?: string | null;
    criteriaOrder?: string | null;
    criteriaLimitedSearch?: boolean;
    criteriaOrderingCode?: string | null;
    criteriaTrackingNumber?: string | null;
    criteriaOrderStatus?: OrderSearchStatus;
    criteriaDateTimeFrom?: Date | null;
    criteriaDateTimeTo?: Date | null;
    criteriaEtcdIcvCode?: string | null;
    criteriaCountryCode?: string | null;
    criteriaCustomerCode?: string | null;
    criteriaPlantId?: number | null;
    criteriaQuerySortByColumn?: string | null;
    criteriaSortColumn?: string | null;
    criteriaIsAscendingOrder?: boolean;
    criteriaSortItems?: Array<CriteriaSortItem> | null;
    criteriaSkipTotalRowCount?: boolean;
}

export interface ApiOrderItemsGetRequest {
    criteriaPage: number;
    criteriaPageSize: number;
    criteriaSerialNumbers?: Array<string> | null;
    criteriaSerialNumberFrom?: string | null;
    criteriaSerialNumberTo?: string | null;
    criteriaOrderAcknowledgementNumber?: string | null;
    criteriaOrderLineItem?: string | null;
    criteriaSortColumn?: string | null;
    criteriaIsAscendingOrder?: boolean;
    criteriaSortItems?: Array<CriteriaSortItem> | null;
    criteriaSkipTotalRowCount?: boolean;
    criteriaQuerySortByColumn?: string | null;
}

export interface ApiOrderLicenseFilesGetRequest {
    identifier?: string;
    fileName?: string | null;
}

export interface ApiOrderLicensesPutRequest {
    serialNumber?: string | null;
}

export interface ApiOrderNotificationsGetRequest {
    criteriaPage: number;
    criteriaPageSize: number;
    criteriaOrderExists?: boolean | null;
    criteriaQueued?: boolean | null;
    criteriaProcessed?: boolean | null;
    criteriaCreatedFrom?: Date | null;
    criteriaCreatedTo?: Date | null;
    criteriaOrder?: string | null;
    criteriaQuerySortByColumn?: string | null;
    criteriaSortColumn?: string | null;
    criteriaIsAscendingOrder?: boolean;
    criteriaSortItems?: Array<CriteriaSortItem> | null;
    criteriaSkipTotalRowCount?: boolean;
}

export interface ApiOrderOrderItemFilesPostRequest {
    downloadOrderItemsFilesQuery?: DownloadOrderItemsFilesQuery;
}

export interface ApiOrderSalesSupportRequestPostRequest {
    contactSalesSupportCommand?: ContactSalesSupportCommand;
}

export interface ApiOrderShippingDetailFilesGetRequest {
    orderAcknowledgementNumber?: string | null;
    shippingNumber?: string | null;
    documentTypes?: Array<ShippingDetailDocumentTypes> | null;
}

/**
 * 
 */
export class OrderApi extends runtime.BaseAPI {

    /**
     */
    async apiOrderDetailsGetRaw(requestParameters: ApiOrderDetailsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrderDetailsVm>> {
        const queryParameters: any = {};

        if (requestParameters.orderIdentifier !== undefined) {
            queryParameters['OrderIdentifier'] = requestParameters.orderIdentifier;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDetailsVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderDetailsGet(requestParameters: ApiOrderDetailsGetRequest, initOverrides?: RequestInit): Promise<OrderDetailsVm> {
        const response = await this.apiOrderDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderGetRaw(requestParameters: ApiOrderGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrdersVm>> {
        if (requestParameters.criteriaPage === null || requestParameters.criteriaPage === undefined) {
            throw new runtime.RequiredError('criteriaPage','Required parameter requestParameters.criteriaPage was null or undefined when calling apiOrderGet.');
        }

        if (requestParameters.criteriaPageSize === null || requestParameters.criteriaPageSize === undefined) {
            throw new runtime.RequiredError('criteriaPageSize','Required parameter requestParameters.criteriaPageSize was null or undefined when calling apiOrderGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.criteriaCompanyId !== undefined) {
            queryParameters['Criteria.CompanyId'] = requestParameters.criteriaCompanyId;
        }

        if (requestParameters.criteriaOrder !== undefined) {
            queryParameters['Criteria.Order'] = requestParameters.criteriaOrder;
        }

        if (requestParameters.criteriaLimitedSearch !== undefined) {
            queryParameters['Criteria.LimitedSearch'] = requestParameters.criteriaLimitedSearch;
        }

        if (requestParameters.criteriaOrderingCode !== undefined) {
            queryParameters['Criteria.OrderingCode'] = requestParameters.criteriaOrderingCode;
        }

        if (requestParameters.criteriaTrackingNumber !== undefined) {
            queryParameters['Criteria.TrackingNumber'] = requestParameters.criteriaTrackingNumber;
        }

        if (requestParameters.criteriaOrderStatus !== undefined) {
            queryParameters['Criteria.OrderStatus'] = requestParameters.criteriaOrderStatus;
        }

        if (requestParameters.criteriaDateTimeFrom !== undefined) {
            queryParameters['Criteria.DateTimeFrom'] = (requestParameters.criteriaDateTimeFrom as any).toISOString();
        }

        if (requestParameters.criteriaDateTimeTo !== undefined) {
            queryParameters['Criteria.DateTimeTo'] = (requestParameters.criteriaDateTimeTo as any).toISOString();
        }

        if (requestParameters.criteriaEtcdIcvCode !== undefined) {
            queryParameters['Criteria.EtcdIcvCode'] = requestParameters.criteriaEtcdIcvCode;
        }

        if (requestParameters.criteriaCountryCode !== undefined) {
            queryParameters['Criteria.CountryCode'] = requestParameters.criteriaCountryCode;
        }

        if (requestParameters.criteriaCustomerCode !== undefined) {
            queryParameters['Criteria.CustomerCode'] = requestParameters.criteriaCustomerCode;
        }

        if (requestParameters.criteriaPlantId !== undefined) {
            queryParameters['Criteria.PlantId'] = requestParameters.criteriaPlantId;
        }

        if (requestParameters.criteriaQuerySortByColumn !== undefined) {
            queryParameters['Criteria.QuerySortByColumn'] = requestParameters.criteriaQuerySortByColumn;
        }

        if (requestParameters.criteriaSortColumn !== undefined) {
            queryParameters['Criteria.SortColumn'] = requestParameters.criteriaSortColumn;
        }

        if (requestParameters.criteriaIsAscendingOrder !== undefined) {
            queryParameters['Criteria.IsAscendingOrder'] = requestParameters.criteriaIsAscendingOrder;
        }

        if (requestParameters.criteriaSortItems) {
            queryParameters['Criteria.SortItems'] = requestParameters.criteriaSortItems;
        }

        if (requestParameters.criteriaPage !== undefined) {
            queryParameters['Criteria.Page'] = requestParameters.criteriaPage;
        }

        if (requestParameters.criteriaPageSize !== undefined) {
            queryParameters['Criteria.PageSize'] = requestParameters.criteriaPageSize;
        }

        if (requestParameters.criteriaSkipTotalRowCount !== undefined) {
            queryParameters['Criteria.SkipTotalRowCount'] = requestParameters.criteriaSkipTotalRowCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdersVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderGet(requestParameters: ApiOrderGetRequest, initOverrides?: RequestInit): Promise<OrdersVm> {
        const response = await this.apiOrderGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderItemsGetRaw(requestParameters: ApiOrderItemsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrderItemsVm>> {
        if (requestParameters.criteriaPage === null || requestParameters.criteriaPage === undefined) {
            throw new runtime.RequiredError('criteriaPage','Required parameter requestParameters.criteriaPage was null or undefined when calling apiOrderItemsGet.');
        }

        if (requestParameters.criteriaPageSize === null || requestParameters.criteriaPageSize === undefined) {
            throw new runtime.RequiredError('criteriaPageSize','Required parameter requestParameters.criteriaPageSize was null or undefined when calling apiOrderItemsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.criteriaSerialNumbers) {
            queryParameters['Criteria.SerialNumbers'] = requestParameters.criteriaSerialNumbers;
        }

        if (requestParameters.criteriaSerialNumberFrom !== undefined) {
            queryParameters['Criteria.SerialNumberFrom'] = requestParameters.criteriaSerialNumberFrom;
        }

        if (requestParameters.criteriaSerialNumberTo !== undefined) {
            queryParameters['Criteria.SerialNumberTo'] = requestParameters.criteriaSerialNumberTo;
        }

        if (requestParameters.criteriaOrderAcknowledgementNumber !== undefined) {
            queryParameters['Criteria.OrderAcknowledgementNumber'] = requestParameters.criteriaOrderAcknowledgementNumber;
        }

        if (requestParameters.criteriaOrderLineItem !== undefined) {
            queryParameters['Criteria.OrderLineItem'] = requestParameters.criteriaOrderLineItem;
        }

        if (requestParameters.criteriaSortColumn !== undefined) {
            queryParameters['Criteria.SortColumn'] = requestParameters.criteriaSortColumn;
        }

        if (requestParameters.criteriaIsAscendingOrder !== undefined) {
            queryParameters['Criteria.IsAscendingOrder'] = requestParameters.criteriaIsAscendingOrder;
        }

        if (requestParameters.criteriaSortItems) {
            queryParameters['Criteria.SortItems'] = requestParameters.criteriaSortItems;
        }

        if (requestParameters.criteriaPage !== undefined) {
            queryParameters['Criteria.Page'] = requestParameters.criteriaPage;
        }

        if (requestParameters.criteriaPageSize !== undefined) {
            queryParameters['Criteria.PageSize'] = requestParameters.criteriaPageSize;
        }

        if (requestParameters.criteriaSkipTotalRowCount !== undefined) {
            queryParameters['Criteria.SkipTotalRowCount'] = requestParameters.criteriaSkipTotalRowCount;
        }

        if (requestParameters.criteriaQuerySortByColumn !== undefined) {
            queryParameters['Criteria.QuerySortByColumn'] = requestParameters.criteriaQuerySortByColumn;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/items`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderItemsVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderItemsGet(requestParameters: ApiOrderItemsGetRequest, initOverrides?: RequestInit): Promise<OrderItemsVm> {
        const response = await this.apiOrderItemsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderLicenseFilesGetRaw(requestParameters: ApiOrderLicenseFilesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.identifier !== undefined) {
            queryParameters['Identifier'] = requestParameters.identifier;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/licenseFiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiOrderLicenseFilesGet(requestParameters: ApiOrderLicenseFilesGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiOrderLicenseFilesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderLicensesPutRaw(requestParameters: ApiOrderLicensesPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrderLicensesVm>> {
        const queryParameters: any = {};

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serialNumber'] = requestParameters.serialNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/licenses`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderLicensesVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderLicensesPut(requestParameters: ApiOrderLicensesPutRequest, initOverrides?: RequestInit): Promise<OrderLicensesVm> {
        const response = await this.apiOrderLicensesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderMetaDataGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrderMetaDataVm>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/metaData`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMetaDataVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderMetaDataGet(initOverrides?: RequestInit): Promise<OrderMetaDataVm> {
        const response = await this.apiOrderMetaDataGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderNotificationsGetRaw(requestParameters: ApiOrderNotificationsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrderNotificationsVm>> {
        if (requestParameters.criteriaPage === null || requestParameters.criteriaPage === undefined) {
            throw new runtime.RequiredError('criteriaPage','Required parameter requestParameters.criteriaPage was null or undefined when calling apiOrderNotificationsGet.');
        }

        if (requestParameters.criteriaPageSize === null || requestParameters.criteriaPageSize === undefined) {
            throw new runtime.RequiredError('criteriaPageSize','Required parameter requestParameters.criteriaPageSize was null or undefined when calling apiOrderNotificationsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.criteriaOrderExists !== undefined) {
            queryParameters['Criteria.OrderExists'] = requestParameters.criteriaOrderExists;
        }

        if (requestParameters.criteriaQueued !== undefined) {
            queryParameters['Criteria.Queued'] = requestParameters.criteriaQueued;
        }

        if (requestParameters.criteriaProcessed !== undefined) {
            queryParameters['Criteria.Processed'] = requestParameters.criteriaProcessed;
        }

        if (requestParameters.criteriaCreatedFrom !== undefined) {
            queryParameters['Criteria.CreatedFrom'] = (requestParameters.criteriaCreatedFrom as any).toISOString();
        }

        if (requestParameters.criteriaCreatedTo !== undefined) {
            queryParameters['Criteria.CreatedTo'] = (requestParameters.criteriaCreatedTo as any).toISOString();
        }

        if (requestParameters.criteriaOrder !== undefined) {
            queryParameters['Criteria.Order'] = requestParameters.criteriaOrder;
        }

        if (requestParameters.criteriaQuerySortByColumn !== undefined) {
            queryParameters['Criteria.QuerySortByColumn'] = requestParameters.criteriaQuerySortByColumn;
        }

        if (requestParameters.criteriaSortColumn !== undefined) {
            queryParameters['Criteria.SortColumn'] = requestParameters.criteriaSortColumn;
        }

        if (requestParameters.criteriaIsAscendingOrder !== undefined) {
            queryParameters['Criteria.IsAscendingOrder'] = requestParameters.criteriaIsAscendingOrder;
        }

        if (requestParameters.criteriaSortItems) {
            queryParameters['Criteria.SortItems'] = requestParameters.criteriaSortItems;
        }

        if (requestParameters.criteriaPage !== undefined) {
            queryParameters['Criteria.Page'] = requestParameters.criteriaPage;
        }

        if (requestParameters.criteriaPageSize !== undefined) {
            queryParameters['Criteria.PageSize'] = requestParameters.criteriaPageSize;
        }

        if (requestParameters.criteriaSkipTotalRowCount !== undefined) {
            queryParameters['Criteria.SkipTotalRowCount'] = requestParameters.criteriaSkipTotalRowCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderNotificationsVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderNotificationsGet(requestParameters: ApiOrderNotificationsGetRequest, initOverrides?: RequestInit): Promise<OrderNotificationsVm> {
        const response = await this.apiOrderNotificationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderNotificationsMetadataGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<OrderNotificationsMetadataVm>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/notificationsMetadata`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderNotificationsMetadataVmFromJSON(jsonValue));
    }

    /**
     */
    async apiOrderNotificationsMetadataGet(initOverrides?: RequestInit): Promise<OrderNotificationsMetadataVm> {
        const response = await this.apiOrderNotificationsMetadataGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderOrderItemFilesPostRaw(requestParameters: ApiOrderOrderItemFilesPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/orderItemFiles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DownloadOrderItemsFilesQueryToJSON(requestParameters.downloadOrderItemsFilesQuery),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiOrderOrderItemFilesPost(requestParameters: ApiOrderOrderItemFilesPostRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiOrderOrderItemFilesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrderSalesSupportRequestPostRaw(requestParameters: ApiOrderSalesSupportRequestPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/salesSupportRequest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactSalesSupportCommandToJSON(requestParameters.contactSalesSupportCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrderSalesSupportRequestPost(requestParameters: ApiOrderSalesSupportRequestPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiOrderSalesSupportRequestPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrderShippingDetailFilesGetRaw(requestParameters: ApiOrderShippingDetailFilesGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.orderAcknowledgementNumber !== undefined) {
            queryParameters['OrderAcknowledgementNumber'] = requestParameters.orderAcknowledgementNumber;
        }

        if (requestParameters.shippingNumber !== undefined) {
            queryParameters['ShippingNumber'] = requestParameters.shippingNumber;
        }

        if (requestParameters.documentTypes) {
            queryParameters['DocumentTypes'] = requestParameters.documentTypes;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aad-jwt", []);
        }

        const response = await this.request({
            path: `/api/Order/shippingDetailFiles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async apiOrderShippingDetailFilesGet(requestParameters: ApiOrderShippingDetailFilesGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.apiOrderShippingDetailFilesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
